import type { RouterConfig } from "@nuxt/schema"

export default <RouterConfig>{
  routes: otherRoutes => [
    // Redirects
    {
      path: "/am",
      component: h("div"),
      async beforeEnter() {
        await useOidcClient().authorize()
        await navigateTo({ name: "hjem" })
      },
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: to => {
        console.info(
          "[404] - Redirected because no valid path was found",
        )
        return {
          name: "404",
          query: {
            from: to.path,
            r: `Vi fant ikke siden du prøvde å nå "${to.path}".`,
          },
        }
      },
    },
    {
      path: "/registrer",
      redirect: to => {
        return {
          name: "404",
          query: {
            from: to.path,
            r: `Siden du prøvde å nå "${to.path}" har blitt flyttet. Registrering gjøres nå via forsidene våre.`,
          },
        }
      },
    },
    {
      path: "/tilbakestill-passord",
      redirect: to => {
        return {
          name: "404",
          query: {
            from: to.path,
            r: "Tilbakestilling av passord støttes ikke lenger, og du er nødt til å opprette en bruker gjennom Vipps.",
          },
        }
      },
    },
    {
      path: "/produkter/organisasjonsatferd-og-ledelse/:catchAll(.*)?",
      redirect: to => {
        return {
          name: "404",
          query: {
            from: to.path,
            r: `Vi fant ikke siden du prøvde å nå "${to.path}".`,
          },
        }
      },
    },
    ...otherRoutes,
  ],

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return { el: to.hash, top: 300 }
    } else if (to.path !== from.path) {
      return { top: 0 }
    }
  },
}
